import { EnumType, RangeType } from "./enums";

export const PERSON_TYPES = {
    PUBLIC: 'public',
    VICTIM: 'victim'
} as const;

export const AGE_RANGES_CONST: readonly RangeType[] = [
    {imperial: 'Infant (0-1)', metric: 'Infant (0-1)', value: 0 },
    {imperial: 'Toddler (1-4)', metric: 'Toddler (1-4)', value: 5 },
    {imperial: 'School Age (4-12)', metric: 'School Age (4-12)', value: 6 },
    {imperial: 'Teenager (13-18)', metric: 'Teenager (13-18)', value: 7 },
    { imperial: '19-30', metric: '19-30', value: 1 },
    { imperial: '31-50', metric: '31-50', value: 2 },
    { imperial: '51-70', metric: '51-70', value: 3 },
    { imperial: '71+', metric: '71+', value: 4 },
] as const;

export const HEIGHT_RANGES_CONST: readonly RangeType[] = [
    { imperial: '-3’', metric: '0-90 cm', value: 0 },
    { imperial: '3’-5’', metric: '91-150 cm', value: 1 },
    { imperial: '5’-6’', metric: '151-180 cm', value: 2 },
    { imperial: '6’+', metric: '181+ cm', value: 3 }
] as const;

export const WEIGHT_RANGES_CONST: readonly RangeType[] = [
    { imperial: '0-100 lbs', metric: '0-45 kg', value: 0 },
    { imperial: '100-200 lbs', metric: '46-90 kg', value: 1 },
    { imperial: '200-300 lbs', metric: '91-135 kg', value: 2 },
    { imperial: '300-400 lbs', metric: '136-180 kg', value: 3 },
    { imperial: '400+ lbs', metric: '181+ kg', value: 4 }
] as const;

export const GENDER_CONST: readonly EnumType[] = [
    { label: 'Male', localizedLabel: 'person.gender.male', value: 0 },
    { label: 'Female', localizedLabel: 'person.gender.female', value: 1 },
    { label: 'Other', localizedLabel: 'person.gender.other', value: 2 }
] as const;

export const EYE_COLORS_CONST: readonly EnumType[] = [
    { label: 'Brown', localizedLabel: 'person.eyeColor.brown', value: 0 },
    { label: 'Blue', localizedLabel: 'person.eyeColor.blue', value: 1 },
    { label: 'Green', localizedLabel: 'person.eyeColor.green', value: 2 },
    { label: 'Other', localizedLabel: 'person.eyeColor.other', value: 3 }
] as const;

export const HAIR_COLORS_CONST: readonly EnumType[] = [
    { label: 'Black', localizedLabel: 'person.hairColor.black', value: 0 },
    { label: 'Brown', localizedLabel: 'person.hairColor.brown', value: 1 },
    { label: 'Blonde', localizedLabel: 'person.hairColor.blonde', value: 2 },
    { label: 'Gray', localizedLabel: 'person.hairColor.gray', value: 3 },
    { label: 'Bald', localizedLabel: 'person.hairColor.bald', value: 4 },
    { label: 'Other', localizedLabel: 'person.hairColor.other', value: 5 }
] as const;


export const SCARS_LABEL = { label: 'Scars', localizedLabel: 'person.features.scars', value: 1 };
export const TATTOO_LABEL = { label: 'Tattoo', localizedLabel: `person.features.tattoo`, value: 4 };

export const FEATURES_CONST: readonly EnumType[] = [
    { label: 'Glasses', localizedLabel: 'person.features.glasses', value: 0 },
    SCARS_LABEL,
    { label: 'Braces', localizedLabel: 'person.features.braces', value: 2 },
    { label: 'Piercings', localizedLabel: 'person.features.piercings', value: 3 },
    TATTOO_LABEL,
] as const;

export const RELATIONSHIPS_CONST: readonly EnumType[] = [
    {label: 'Parent', localizedLabel: 'person.relationship.parent', value: 0},
    {label: 'Child', localizedLabel: 'person.relationship.child', value: 1},
    {label: 'Spouse', localizedLabel: 'person.relationship.spouse', value: 2},
    {label: 'Significant Other', localizedLabel: 'person.relationship.significantOther', value: 3},
    {label: 'Sibling', localizedLabel: 'person.relationship.sibling', value: 4},
    {label: 'Grandparent', localizedLabel: 'person.relationship.grandparent', value: 5},
    {label: 'Friend', localizedLabel: 'person.relationship.friend', value: 6},
    {label: 'Coworker', localizedLabel: 'person.relationship.coworker', value: 7},
] as const;

export const STATUS_OPTIONS_CONST = [
  'Alive',
  'Deceased',
  'Alive - Unable to Answer Questions/Speak'
] as const;

// Types
export type PersonType = typeof PERSON_TYPES[keyof typeof PERSON_TYPES];

export type Gender = typeof GENDER_CONST[number];
export type EyeColor = typeof EYE_COLORS_CONST[number];
export type HairColor = typeof HAIR_COLORS_CONST[number];
export type Feature = typeof FEATURES_CONST[number];
export type Relationship = typeof RELATIONSHIPS_CONST[number];
export type AgeRange = typeof AGE_RANGES_CONST[number];
export type HeightRange = typeof HEIGHT_RANGES_CONST[number];
export type WeightRange = typeof WEIGHT_RANGES_CONST[number];
export type StatusOption = typeof STATUS_OPTIONS_CONST[number];

export const PERSON_ENUMS = {
    GENDER: [...GENDER_CONST],
    AGE_RANGES: [...AGE_RANGES_CONST],
    HEIGHT_RANGES: [...HEIGHT_RANGES_CONST],
    WEIGHT_RANGES: [...WEIGHT_RANGES_CONST],
    EYE_COLORS: [...EYE_COLORS_CONST],
    HAIR_COLORS: [...HAIR_COLORS_CONST],
    FEATURES: [...FEATURES_CONST],
    RELATIONSHIPS: [...RELATIONSHIPS_CONST],
    STATUS_OPTIONS: [...STATUS_OPTIONS_CONST],
}
